/* eslint-disable warp-drive/no-legacy-request-patterns */
import Base from 'linced-enrolments/routes/base';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import type Controller from '@ember/controller';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import type { AppStore } from 'linced-enrolments/types/store';

// A type alias, not an interface: aliases satisfy Route.model's
// `Record<string, unknown>` params, interfaces do not.
type Params = {
  country_code: string;
  school_code: string;
};

type Model = Awaited<ReturnType<AppStore['query']>>;

export default class ApplyCompleteRoute extends Base<Model> {
  // Services
  @service
  declare router: RouterService;

  @service
  declare store: AppStore;

  model({ country_code, school_code }: Params) {
    return this.store.query('enrolments/schema', {
      // The backend stores the country code in upper case and compares it exactly.
      countryCode: country_code.toUpperCase(),
      schoolCode: school_code,
    });
  }

  setupController(
    controller: Controller,
    model: Model,
    transition: Transition,
  ) {
    // Call _super for default behavior
    super.setupController(controller, model, transition);

    // Extract schema object or redirect to not found.
    if (isEmpty(model)) {
      this.router.transitionTo('school-not-found');
    } else {
      controller.set('schema', model.at(0));
    }
  }
}
